import React, { FC } from 'react';

const iconCoffeeCup = require('./icon_coffee_cup.svg');

export const IconCoffeeCup: FC = () => {
  return <img src={iconCoffeeCup} width={71} height={87} alt="icon_coffee_cup" />;
};

IconCoffeeCup.displayName = 'IconCoffeeCup';
